import React, { useEffect, useRef } from 'react'
import { INotification } from '../../../context/notficationContext'
import './notification.css'
import { Cross } from '../../svg/svg'

export interface INotificationProps {
  notification: INotification
}

const Notification = (props: INotificationProps) => {
  let reasons
  let message = props.notification.message
  const notificationRef = useRef<HTMLDivElement>(null)
  let duration =
    props.notification.duration === undefined ? 5 : props.notification.duration
  let borderColor = '#C579F6ff'
  let bgColor = '#11013Aff'
  switch (props.notification.type) {
    case 'success':
      borderColor = '#02C20F'
      bgColor = '#E7F9F1'
      break
    case 'fail':
      borderColor = '#FF000D'
      bgColor = '#FAEDED'
      break
    case 'warning':
      borderColor = '#FFBF00'
      bgColor = '#FFF8E3'
      break
  }
  if (props.notification.reasons !== undefined) {
    reasons = props.notification.reasons.map(
      (reasons: string | React.ReactElement, idx: number) => {
        return (
          <li key={idx}>
            <p style={{ color: borderColor, whiteSpace: 'pre-line' }}>
              {reasons}
            </p>
          </li>
        )
      }
    )
  }
  // let icon = info
  useEffect(() => {
    const rmInterval = setInterval(() => {
      try {
        if (!notificationRef.current) return
        notificationRef.current.remove()
      } catch (err) {}
    }, duration * 1000)
    return () => {
      clearInterval(rmInterval)
    }
  })
  return (
    <div
      ref={notificationRef}
      className="notification"
      style={{ backgroundColor: bgColor }}
    >
      {/* <div
            className="notificationBar"
            style={{backgroundColor: borderColor}}
            /> */}
      {/* <img className="notificationIcon" src={icon}/> */}
      <Cross
        onClick={() => {
          try {
            if (!notificationRef.current) return
            notificationRef.current.remove()
          } catch (err) {}
        }}
        className="closeNotification"
        style={{ fill: borderColor }}
      />
      <div className="notificationMsgContainer">
        <p style={{ color: borderColor, whiteSpace: 'pre-line' }}>{message}</p>
        {reasons !== undefined ? (
          <>
            <ul>{reasons}</ul>
          </>
        ) : null}
      </div>
    </div>
  )
}

export default Notification
